export default __webpack_public_path__ + "static/media/ff1.08ba4da0.jpg";